import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { Reveal } from '../Reveal';
import { useLanguage } from '../../contexts/LanguageContext';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-white py-24 sm:py-32" aria-labelledby="faq-heading" data-id="element-94" data-mp="12355scfbdgze">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-95" data-mp="1ptip9eju27id">
        <div className="grid gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20" data-id="element-96" data-mp="1ur10jblboytj">
          <Reveal data-id="element-97" data-mp="1ut51plru7jq4">
            <div data-id="element-98" data-mp="1g2o124n10xua">
              <p className="text-[12px] font-semibold uppercase tracking-[0.2em] text-brand" data-id="element-99" data-mp="1g3669qro2mec">
                {t.faq.eyebrow}
              </p>
              <h2 id="faq-heading" className="headline mt-5 text-[32px] font-bold text-ink sm:text-[44px]" data-id="element-100" data-mp="1kzoa8of6agpm">
                {t.faq.heading}
              </h2>
              <p className="mt-6 text-[16px] leading-relaxed text-ink/60" data-id="element-101" data-mp="2di1ufl7l6468">{t.faq.body}</p>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-102" data-mp="2oqqnphp5cnik">
            <ul className="divide-y divide-ink/[0.08] border-y border-ink/[0.08]" data-id="element-103" data-mp="2onw23muecwnk">
              {t.faq.items.map((faq, i) => {
              const isOpen = open === i;
              return <li key={faq.question} data-id="element-104" data-mp="2yhczt1xnmvwi" data-mpi={i}>
                    <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="group flex w-full items-center justify-between gap-6 py-6 text-left" data-id="element-105" data-mp="2tplep6x9pidr">
                      <span className="text-[17px] font-semibold tracking-tight text-ink transition-colors duration-300 group-hover:text-brand sm:text-[19px]" data-id="element-106" data-mp="32hncsyjv6mkv">
                        {faq.question}
                      </span>
                      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-all duration-300 ${isOpen ? 'rotate-45 border-brand bg-brand text-white' : 'border-ink/12 text-ink/60 group-hover:border-ink/30'}`} aria-hidden="true" data-id="element-107" data-mp="3cfjlljpbx5ft">
                        <PlusIcon className="h-4 w-4" data-id="element-108" data-mp="27q7c0prezgwg" />
                      </span>
                    </button>
                    <AnimatePresence initial={false} data-id="element-109" data-mp="2bqznzqro7zwf">
                      {isOpen && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.32,
                    ease: [0.22, 1, 0.36, 1]
                  }} className="overflow-hidden" data-id="element-110" data-mp="2btceisbhvil3">
                          <p className="max-w-[620px] pb-7 pr-10 text-[15px] leading-relaxed text-ink/65" data-id="element-111" data-mp="2zhn9jeuieo1g">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>;
}